import React from 'react'
import './Modal.css'
import { LiaTimesSolid } from 'react-icons/lia'

export default function Modal({ isOpen = false, setIsOpen, children, title, subtitle }) {
    return (
        <>
            {isOpen && (
                <div className="general-modal-overlay">
                    <div className="general-modal-container">
                        <div className="general-modal-header">
                            <button className="close-button" onClick={() => setIsOpen(false)}>
                                <LiaTimesSolid size={22} color="rgba(152, 162, 179, 1)" />
                            </button>
                            <span style={{ paddingInline: "20px", boxSizing: "border-box" }}>
                                {title}
                                <div className="general-modal-subtitle">
                                    {subtitle}
                                </div>
                            </span>
                        </div>
                        {children}
                    </div>
                </div>
            )
            }
        </>
    )
}
